import React, { useState, useEffect }  from 'react';
import { useQuery } from '@apollo/client';
import { get } from 'lodash';
import safeJsonParse from '@td/emr/src/utils/json/safeJsonParse';
import tasFetchPatientConsent from './graphql/queries/tasFetchPatientConsent.graphql';
import EditPatientConsent from './components/EditPatientConsent';
import PatientConsentHeader from './components/PatientConsentHeader';
import ShowTableOrNoPatientConsent from './components/ShowTableOrNoPatientConsent';
import styles from './styles.module.scss';

const getResponse = (data) => get(data, 'member.fetchPatientConsent');

const PatientConsentForMedicalRecordsExchange = ({ memberId }) => {
  const [showEditForm, setShowEditForm] = useState(false);
  const [patientConsentData, setPatientConsentData] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [consent, setConsent] = useState(false);
  const [flag, setFlag] = useState('N');
  const [hideEditButton, setHideEditButton] = useState(false);

  const { loading, error, data } = useQuery(tasFetchPatientConsent, {
    variables: { member_id: memberId }
  });

  useEffect(() => {
    if (data) {
      const response = getResponse(data);

      setPatientConsentData(safeJsonParse(response));
    }
  }, [data]);

  useEffect(() => {
    if (patientConsentData) {
      setShowTable(true);

      if (patientConsentData.answer === 'Y') {
        setConsent(true);
        setFlag('Y');
      } else {
        setConsent(false);
        setFlag('N');
      }
    }
  }, [patientConsentData])

  const handleEditClick = () => {
    setShowEditForm(true);
    setHideEditButton(true);
  }

  const handleButtonClick = () => {
    setShowEditForm(false);
    setHideEditButton(false);
  }

  return (
    <div>
      <PatientConsentHeader onHandleEditClick={handleEditClick} showEditButton={hideEditButton} />
      <div className={styles.mainContent}>
        {showEditForm ? 
          <EditPatientConsent 
            onHandleButtonClick={handleButtonClick} 
            memberId={memberId} consent={consent} 
            approvalResponseFlag={flag} 
          /> : 
          <ShowTableOrNoPatientConsent 
            memberId={memberId} 
            patientConsentData={patientConsentData} 
            showTable={showTable} 
            loading={loading}
            error={error}
          /> }
      </div>
    </div>
  )
}

export default PatientConsentForMedicalRecordsExchange;